module.exports = __webpack_public_path__ + "static/media/female_adult.35157f84.svg";